export class VehicleWarnings {
  constructor(public gpsOffline: boolean,
              public dvrOffline: boolean,
              public tabOffline: boolean,
              public alarms: string[]) {
  }
}
